import React, { useState } from 'react';
import './ThemeSwitcher.css';
import { ThemeType, useTheme } from '../context/ThemeContext';

const themes: { id: ThemeType; name: string; colors: string[] }[] = [
  { id: 'original', name: 'Original', colors: ['#7A8C76', '#A65D4F', '#F3E9DC'] },
  { id: 'forest', name: 'Forest Mist', colors: ['#4A5D4E', '#8B4513', '#F1F3F2'] },
  { id: 'sunset', name: 'Sunset Glow', colors: ['#8D99AE', '#E76F51', '#FEFAE0'] },
  { id: 'ocean', name: 'Ocean Calm', colors: ['#588157', '#344E41', '#DAD7CD'] },
  { id: 'lavender', name: 'Soft Lavender', colors: ['#7B6D8D', '#9D8189', '#FBF9FF'] },
];

export const ThemeSwitcher = () => {
  const { theme, setTheme } = useTheme();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="theme-switcher">
      {isOpen && (
        <div className="theme-switcher-panel" role="dialog" aria-label="Välj tema">
          <div className="theme-switcher-panel-header">
            <h3 className="theme-switcher-panel-title">Välj tema</h3>
            <button
              type="button"
              onClick={() => setIsOpen(false)}
              className="theme-switcher-close"
              aria-label="Stäng temaväljare"
            >
              ×
            </button>
          </div>

          <div className="theme-switcher-list">
            {themes.map((t) => (
              <button
                key={t.id}
                type="button"
                onClick={() => setTheme(t.id)}
                className={`theme-switcher-option ${theme === t.id ? 'is-active' : ''}`}
              >
                <div className="theme-switcher-option-main">
                  <div className="theme-switcher-swatches" aria-hidden="true">
                    {t.colors.map((c, i) => (
                      <span key={i} style={{ backgroundColor: c }} />
                    ))}
                  </div>
                  <span className="theme-switcher-option-name">{t.name}</span>
                </div>
                {theme === t.id && <span className="theme-switcher-option-mark">✓</span>}
              </button>
            ))}
          </div>
        </div>
      )}

      <button
        type="button"
        onClick={() => setIsOpen(prev => !prev)}
        className={`theme-switcher-trigger ${isOpen ? 'theme-switcher-trigger-open' : ''}`}
        aria-label="Öppna temaväljare"
        aria-expanded={isOpen}
      >
        <span className="theme-switcher-trigger-icon">{isOpen ? '×' : '◐'}</span>
      </button>
    </div>
  );
};
